// 吸音パネルサイズの一覧（面積を直接指定）
    const panelSizes = [
      { name: "OTTO R 30cm×30cm", dimension: 0.09 },
      { name: "OTTO R 60cm×30cm", dimension: 0.18 },
      { name: "OTTO R 六角形", dimension: 0.081 },
      { name: "OTTO R 丸型 φ30cm", dimension: 0.07 },
      { name: "OTTO R 丸型 φ45cm", dimension: 0.16 },
      { name: "REBORN PULP吸音パネル", dimension: 0.09 }
    ];

    function calculateRecommendations() {
      // 入力値の取得
      const length = parseFloat(document.getElementById('length').value);
      const width  = parseFloat(document.getElementById('width').value);
      const height = parseFloat(document.getElementById('height').value);

      // すべての項目に有効な数値が入力されているかを確認
      if (isNaN(length) || isNaN(width) || isNaN(height)) {
        alert('全ての項目に数値を入力してください。');
        return;
      }

      // 壁面積の計算（長辺と短辺両方の壁×高さ×2面ずつ）
      const wallArea = (length * height * 2) + (width * height * 2);
      // 壁面の10%と6%の面積
      const wallArea10 = wallArea * 0.1;
      const wallArea6  = wallArea * 0.06;

      // パネルごとの結果セルを更新
      panelSizes.forEach((panel, index) => {
        const panelArea = panel.dimension; // 各パネルの面積（例：0.09）
        const recommendedA = wallArea10 / panelArea; // 10%の場合
        const recommendedB = wallArea6  / panelArea;  // 6%の場合
        const resultText = `${Math.round(recommendedB)} 枚 ～ ${Math.round(recommendedA)} 枚`;
        document.getElementById(`result-${index}`).textContent = resultText;
      });
    }
